import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import { handleApiAuthError, expireSession } from "./utils/authSession";
import "@/index.css";
import App from "@/App";
import { installGlobalErrorHandlers } from "@/utils/frontLogger";

// AUDIT 2026-07-06: глобальный interceptor на module-level axios. «Голые» axios-вызовы
// (MarketMaker.jsx/WalletManager.jsx, ~99 шт) не проходили через api.js-инстанс и НЕ слали
// JWT. Готовит /api/market-maker и /api/wallets к auth-enforcement (Фаза 2). Backend без
// auth просто игнорирует заголовок → эта правка ничего не ломает.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  const target = new URL(config.url || "", config.baseURL || window.location.href);
  if (token && target.origin === window.location.origin && target.pathname.startsWith("/api/") && !config.headers?.Authorization) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
  }
  return config;
});

axios.interceptors.response.use(response => response, error => {
  handleApiAuthError(error);
  return Promise.reject(error);
});

// AUDIT 2026-07-06: 6 карт (ToxicFlow/DryRun/Buyback/Bounce/DexHealth/DailyPnL) ходят
// голым fetch() к /api/market-maker/* — axios-interceptor их не покрывает. Патчим
// window.fetch: добавляем Bearer ТОЛЬКО к нашим /api/-вызовам (внешние — tonconnect,
// CDN — не содержат '/api/' и не трогаются). Не перетираем уже заданный Authorization.
const _origFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
  let sentToken = null;
  try {
    const token = localStorage.getItem("auth_token");
    const url = typeof input === "string" ? input : (input && input.url) || "";
    if (token && new URL(url, window.location.href).origin === window.location.origin && new URL(url, window.location.href).pathname.startsWith("/api/")) {
      const headers = Object.fromEntries(new Headers(init.headers || (input instanceof Request ? input.headers : {})).entries());
      if (!headers.Authorization && !headers.authorization) {
        headers.Authorization = `Bearer ${token}`;
        init = { ...init, headers };
      }
      const authorization = headers.Authorization || headers.authorization || '';
      if (authorization.startsWith('Bearer ')) sentToken = authorization.slice(7);
    }
  } catch (e) { /* fetch-патч не должен ломать запрос */ }
  return _origFetch(input, init).then(response => {
    if (response.status === 401) expireSession(sentToken);
    return response;
  });
};

// Telemetry Phase 2: uncaught errors + unhandledrejection → backend.
installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
